import Vue   from "vue";
import Vuex  from "vuex";

Vue.use(Vuex)

import reservation       from "../reservations/advance";
import prepareVuexConfig from "./vuex_config";


const store = new Vuex.Store(await prepareVuexConfig(reservation))

export default store;
